module.exports = __webpack_public_path__ + "img/17.d94d6b45.jpg";